// extracted by mini-css-extract-plugin
module.exports = {"container":"Hu","timeTop":"Iu","timeCountdown":"Ju","cta":"Ku","disabled":"Lu","product":"Mu"};